<template>
  <svg
    width="18"
    height="18"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.10225 4.40064L8.00003 7.97781L14.8978 4.40064M8.00003 15.1109V7.97072M15.1111 10.8041V5.13732C15.1109 4.88888 15.0377 4.64488 14.899 4.42979C14.7603 4.21471 14.561 4.03609 14.321 3.91187L8.79015 1.07847C8.54992 0.954132 8.27742 0.888672 8.00003 0.888672C7.72264 0.888672 7.45013 0.954132 7.2099 1.07847L1.67904 3.91187C1.43905 4.03609 1.23972 4.21471 1.10103 4.42979C0.962352 4.64488 0.8892 4.88888 0.888916 5.13732V10.8041C0.8892 11.0526 0.962352 11.2966 1.10103 11.5116C1.23972 11.7267 1.43905 11.9054 1.67904 12.0296L7.2099 14.863C7.45013 14.9873 7.72264 15.0528 8.00003 15.0528C8.27742 15.0528 8.54992 14.9873 8.79015 14.863L14.321 12.0296C14.561 11.9054 14.7603 11.7267 14.899 11.5116C15.0377 11.2966 15.1109 11.0526 15.1111 10.8041Z"
      stroke="currentColor"
      stroke-width="1.4"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script setup>
</script>
